import find from "lodash/fp/find";
import filter from "lodash/fp/filter";
import flow from "lodash/fp/flow";
import getOr from "lodash/fp/getOr";
import isString from "lodash/fp/isString";
import uniq from "lodash/fp/uniq";

import { getObjectPrimitiveValues, isImageUrl } from "utils";

export default function selectAllImageUrlsForProduct({ productId }) {
  return flow(
    getOr([], ["app", "formData", "products"]),
    find(({ id }) => id === productId),
    getObjectPrimitiveValues,
    filter(isString),
    filter(isImageUrl),
    uniq
  );
}
